<script>
    export let ingredientData;
    export let selected=false;
    export let clickCallback;

    $:tru_select = false;

    let ingredientBox;
    //"ingredient-box {tru_select ? 'selected-ingredient': ''}
    function toggle_selected(){
        console.log(ingredientBox.className);
        if(ingredientBox.className.indexOf('selected-ingredient') < 0){
            ingredientBox.classList.add('selected-ingredient')
        }else{
            ingredientBox.classList.add('removeBg');
            setTimeout(()=>{
                ingredientBox.classList.remove('removeBg');
                ingredientBox.classList.remove('selected-ingredient')
            }, 250)

        }
    }
</script>

<style>
    .ingredient-box{
        margin: 16px;
        width: 120px;
        height: 120px;
        border: 0;
        transition: all .25s ease-in-out;
        z-index: 2;
    }
    .selected-ingredient{
        margin-top: 8px;
        border: 8px solid white;
        border-image: url('/img/chalkboard/answer-box.png') 20;
    }
    @keyframes remove_bg {
        from {
            border: 8px solid white;
            margin-top: 8px;
        }
        to {
            border: 0;
            margin-top: 16px;
        }
    }
    .removeBg{
        animation: remove_bg .25s ease-in-out;
    }
    .ingredient-picture{
        width: 100%;
        height: 80%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

<div bind:this={ingredientBox} class="ingredient-box" on:click="{e => {toggle_selected(); clickCallback(ingredientData.value)}}">
    <div class="ingredient-box selected-ingredient removeBg" style="display:none"></div>
    <div class="ingredient-picture">
        <img src={ingredientData.img} alt={ingredientData.name} />
    </div>
    <div class="cursive-text text-center" style="text-align:center; width: 100%">{ingredientData.name}</div>
</div>